import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v3/data/products/categories';

class ProductCategory {
  index() {
    return Axios.get(API_URL);
  }

  show(productcategory) {
    return Axios.get(API_URL + `/${productcategory}`);
  }
}

export default new ProductCategory();



// WEBPACK FOOTER //
// ./src/api/productcategoryv3.js